export function isValidEmail(email: string): boolean {
	return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,7}$/i.test(email);
}

export default { isValidEmail };
